// FILECONTENT_START src/common/components/FilePreview/index.ts
import FilePreview from "./FilePreview";
export default FilePreview;

export type { FilePreviewProps, FilePreviewType } from "./FilePreview";
export { default as GlobalFilePreview, previewFile } from "./GlobalFilePreview";

// FILECONTENT_END src/common/components/FilePreview/index.ts